<template>
  <!-- Filter Dialog -->
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2">mdi-filter-variant</v-icon>
        {{ t('title') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <div v-if="itemTypes.length > 0" class="text-subtitle-2 mb-2">{{ t('itemTypes') }}</div>
        <div v-if="itemTypes.length > 0" class="d-flex flex-wrap gap-2">
          <v-btn v-for="type in itemTypes"
                 :key="type.key"
                 @click="emit('toggleType', type.key)"
                 :variant="itemTypeFilters[type.key] ? 'tonal' : 'outlined'"
                 :color="itemTypeFilters[type.key] ? 'primary' : 'grey'"
                 size="small"
                 class="status-filter-btn">
            {{ type.label }}
          </v-btn>
        </div>
        <v-divider v-if="itemTypes.length > 0" class="my-4"></v-divider>
        <div class="text-subtitle-2 mb-2">{{ t('statuses') }}</div>
        <div v-if="statusTemplates.length > 0" class="d-flex flex-wrap gap-2" :key="`statuses-${filterKey}`">
          <v-btn v-for="status in statusTemplates"
                 :key="status.title"
                 @click="emit('toggleStatus', status.title)"
                 :variant="statusFilters[status.title] ? 'tonal' : 'outlined'"
                 :color="statusFilters[status.title] ? status.color : 'grey'"
                 size="small"
                 class="status-filter-btn">
            <div class="status-color-indicator mr-2" :style="{ backgroundColor: status.color }"></div>
            {{ status.title }}
          </v-btn>
        </div>
        <div v-else class="text-center text-medium-emphasis">
          {{ t('noAvailableStatus') }}
        </div>
        <template v-if="extraToggles.length > 0">
          <v-divider class="my-4"></v-divider>
          <v-checkbox v-for="toggle in extraToggles"
                      :key="toggle.key"
                      :modelValue="!!extraToggleValues[toggle.key]"
                      @update:modelValue="emit('toggleExtra', toggle.key)"
                      :label="toggle.label"
                      density="compact"
                      hide-details
                      :color="toggle.color"></v-checkbox>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" variant="text" @click="handleToggleAll">
          {{ allFiltersSelected ? t('deselectAll') : t('selectAll') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="text" @click="dialog = false">
          {{ t('close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <div class="fab-container">
    <v-tooltip :text="t('globalFilters')">
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          icon
          size="large"
          :color="buttonColor"
          variant="tonal"
          @click="dialog = true"
          :class="{ 'filter-active-dark': hasActiveFilter && theme === 'dark', 'filter-active-light': hasActiveFilter && theme === 'light' }"
        >
          <v-icon size="24">mdi-filter-variant</v-icon>
        </v-btn>
      </template>
    </v-tooltip>
  </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
